// WebLLM prebuilt model ids — q4f16_1 = 4-bit quantized float16 (best size/quality).
// Full model list: node_modules/@mlc-ai/web-llm/lib/index.js, search prebuiltAppConfig.

// Static fallback — used to seed Firestore on first load and as default when offline.
export const DEFAULT_SLM_MODELS = [
  // NOTE: q4f32_1 (not q4f16). This GPU (RTX 2070) lacks the WebGPU shader-f16
  // feature, so q4f16 models fail with "Invalid ShaderModule (index_kernel)".
  // f32 variants don't need shader-f16. Keep f32 for any f16-less GPU.
  // Default 1.5B: fits ~8GB VRAM in f32. 3B q4f32 OOMs on an 8GB RTX 2070 but is
  // kept enabled for bigger GPUs. 0.5B is weak (parrots the template) but the
  // strict output schema keeps it from crashing — last-resort lightweight option.
  { modelId: "Qwen2.5-1.5B-Instruct-q4f32_1-MLC", label: "Qwen 2.5 · 1.5B (f32)", size: "~1.6 GB", enabled: true },
  { modelId: "Qwen2.5-3B-Instruct-q4f32_1-MLC",   label: "Qwen 2.5 · 3B (f32)",   size: "~3 GB",   enabled: true },
  { modelId: "Qwen2.5-0.5B-Instruct-q4f32_1-MLC", label: "Qwen 2.5 · 0.5B (f32)", size: "~0.6 GB", enabled: true },
  { modelId: "Qwen3.5-0.8B-q4f16_1-MLC", label: "Qwen 3.5 · 0.8B", size: "~0.8 GB", enabled: false },
  { modelId: "Qwen3.5-2B-q4f16_1-MLC",   label: "Qwen 3.5 · 2B",   size: "~2 GB",   enabled: false },
  { modelId: "Qwen3.5-4B-q4f16_1-MLC",   label: "Qwen 3.5 · 4B",   size: "~4 GB",   enabled: false },
  { modelId: "Qwen3.5-9B-q4f16_1-MLC",   label: "Qwen 3.5 · 9B",   size: "~9 GB",   enabled: false },
];

export const DEFAULT_SLM_MODEL_ID = DEFAULT_SLM_MODELS[0].modelId;

// Legacy compat — still used by slmMentor.js default param
export const DEFAULT_SLM_MODEL = DEFAULT_SLM_MODEL_ID;

// Playful loading verbs shown while the mentor "thinks" — admin-editable via
// Settings (appConfig/global.mentorVerbs); this is the fallback when that
// field is empty/missing. Kept exported unchanged (and still Italian) since
// Settings.jsx's textarea seeds/falls back to this exact list regardless of
// the admin's own UI language.
export const DEFAULT_THINKING_VERBS = [
  'sto ragionando', 'sto seminando', 'sto intrecciando idee',
  'sto connettendo i puntini', 'sto scavando', 'sto disegnando',
  'sto distillando', 'sto annusando l’aria',
];

// Per-language static fallback for the same loading verbs, keyed by the
// app's `lang` (see i18n/langContext.js). `it` reuses DEFAULT_THINKING_VERBS
// verbatim; `en` is a natural-English equivalent (present-participle, same
// playful tone) — NOT a literal translation of each Italian verb.
export const THINKING_VERBS_BY_LANG = {
  it: DEFAULT_THINKING_VERBS,
  en: [
    'thinking it over', 'planting ideas', 'weaving connections',
    'connecting the dots', 'digging in', 'sketching it out',
    'distilling', 'reading the room',
  ],
};

// Resolves which thinking-verb list is active for the mentor's loading
// state. `override` is the raw appConfig/global.mentorVerbs array from
// Firestore (admin-editable) — admins write it in Italian, so it only
// applies when `lang === 'it'`; every other language falls back to
// THINKING_VERBS_BY_LANG, defaulting to English for any language that
// doesn't have its own list yet.
export function pickThinkingVerbs({ lang, override } = {}) {
  if (lang === 'it' && Array.isArray(override) && override.length) return override;
  return THINKING_VERBS_BY_LANG[lang] || THINKING_VERBS_BY_LANG.en;
}
